import Banner from "@/components/landing/countries/Banner";
import SupportedCountries from "@/components/landing/countries/SupportedCountries";

export default function Countries() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Supported Countries section */}
      <SupportedCountries />
    </>
  );
}
